import { supabase } from './supabaseClient';

export interface CountrySettings {
  id: string;
  country_code: string;
  country_name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const fetchCountrySettings = async () => {
  const { data, error } = await supabase
    .from('country_settings')
    .select('*')
    .order('country_name', { ascending: true });

  if (error) {
    throw error;
  }

  return data as CountrySettings[];
};

export const updateCountrySettings = async (countryCode: string, isActive: boolean) => {
  const { data, error } = await supabase
    .from('country_settings')
    .update({ is_active: isActive, updated_at: new Date().toISOString() })
    .eq('country_code', countryCode)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data as CountrySettings;
};

export const addCountrySettings = async (countryCode: string, countryName: string) => {
  const { data, error } = await supabase
    .from('country_settings')
    .insert({
      country_code: countryCode,
      country_name: countryName,
      is_active: false
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data as CountrySettings;
};

export const deleteCountrySettings = async (countryCode: string) => {
  const { error } = await supabase
    .from('country_settings')
    .delete()
    .eq('country_code', countryCode);

  if (error) {
    throw error;
  }
};
